import { Component } from '@angular/core';

@Component({
    selector: 'black-accordion-input',
    templateUrl: './accordion-input.component.html',
    styleUrls: ['./accordion-input.component.css'],
    standalone: false
})
export class AccordionInputComponent {}
